import { toast } from "sonner";

const useToast = () => {
  const showToast = ({ message, type }) => {
    if (type === "success") {
      toast.success(message);
    } else if (type === "info") {
      toast.info(message);
    } else {
      toast.error(message);
    }
  };

  return { showToast };
};

export default useToast;
